import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import FormProvider, { RHFInput, RHFInputTel } from 'Components/Organisms/HookForm';
import Button from 'Components/Atoms/Button/Button';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { matchIsValidTel } from 'Components/Atoms/InputTel/InputTel';
import { useUser } from 'Components/Organisms/UserProvider/useUser';

export default function OnboardingProfileData(props) {
    const { onCompleted, data, isBusy } = props;

    const { t } = useTranslation('onboarding');
    const { user } = useUser();

    const formSchema = yup.object().shape({
        name: yup.string().required(t('name-is-required')),
        surnames: yup.string().required(t('surname-is-required')),
        phone_number: yup
            .string()
            .required(t('phone-number-is-required'))
            .test('is-valid-tel', t('phone-number-is-invalid'), (value) => matchIsValidTel(value.trim())),
    });

    const methods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            name: data.name ?? '',
            surnames: data.surnames ?? '',
            phone_number: data.phone_number ?? '+34',
        },
    });

    const { handleSubmit } = methods;

    const titleKey = user.isOwner ? 'configure-your-profile' : 'configure-member-profile';
    const descriptionKey = user.isOwner ? 'configure-your-profile-description' : 'configure-member-profile-description';

    return (
        <div className="mb-12">
            <div className="py-6">
                <h2 className="text-xl font-bold leading-[1.3] tracking-tight text-dark-blue text-balance md:text-[27px]">
                    {t(titleKey)}
                </h2>
                <p className="text-gray-500">{t(descriptionKey)}</p>
            </div>

            <FormProvider methods={methods} onSubmit={handleSubmit(onCompleted)}>
                <div className="flex flex-col gap-6 mb-6">
                    <RHFInput name="name" label={t('name')} autoFocus autoComplete="given-name" />
                    <RHFInput name="surnames" label={t('surnames')} autoComplete="family-name" />
                    <RHFInputTel name="phone_number" label={t('phone-number')} />
                </div>

                <div className="py-2">
                    <Button variant="primary" type="submit" isBusy={isBusy} className="w-full">
                        {t(user.isOwner ? 'start' : 'start-member')}
                    </Button>
                </div>
            </FormProvider>
        </div>
    );
}

OnboardingProfileData.propTypes = {
    onCompleted: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    isBusy: PropTypes.bool,
};
